export function getStorage(cname) {
    let storageValue = localStorage.getItem(cname);
    if(storageValue){
      return storageValue;
    }  
    return '';
}

export function setStorage(cname,cvalue) {
  localStorage.setItem(cname, cvalue);
  if(cname==='fcmNotificationToken') {
      console.log('localStorage cname: '+cname+', cvalue '+cvalue); 
  }
}

export function getUserGroupData(userGroup) {
  let data = getStorage(userGroup);
  if (data !== '') {
    return JSON.parse(data);
  } else {
    return null;
  }
}